import { lazy, Suspense } from "react";
import { api } from "../lib/api";
import { useApiData } from "../lib/hooks";
import { Loading } from "../components/Loading";

// Lazy-load RoundDetailView so RoundDetail.jsx stays in its own chunk.
// App.jsx also lazy-loads RoundDetail (for /rounds/:id), so Vite will merge
// them into a single shared chunk — no duplication.
const RoundDetailView = lazy(() =>
  import("./RoundDetail").then((m) => ({ default: m.RoundDetailView }))
);

export function Round() {
  // Two chained reads, but still a single read-once fetch from the component's
  // point of view, so it goes through useApiData like the rest (#2068).
  const { data: round, error } = useApiData(
    () =>
      api
        .rounds({ active: false, limit: 1 })
        .then((list) => (list.length ? api.round(list[0].id) : null)),
    [],
  );

  if (!round) {
    return (
      <main className="main">
        <div className="main-head">
          <div>
            <h1>Last round</h1>
            {/* Was `.catch(() => {})`: a failed load rendered the same
                "no completed rounds yet" copy as an empty account (#2068). */}
            <div className="greeting">
              {error ? `Could not load your last round — ${error}` : "No completed rounds yet."}
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <Suspense fallback={<Loading />}>
      <RoundDetailView initialRound={round} />
    </Suspense>
  );
}
